import { Component } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { isAuthenticated, isAuthenticationLoading } from 'src/app/core/auth/selectors';

@Component({
  selector: 'ds-base-home-news',
  styleUrls: ['./home-news.component.scss'],
  templateUrl: './home-news.component.html',
  standalone: true,
})

/**
 * Component to render the news section on the home page
 */
export class HomeNewsComponent {
  public isAuthenticated: Observable<boolean>;
  public loading: Observable<boolean>;
  constructor(private store:Store<AppState>){}
  ngOnInit(): void {
    this.isAuthenticated = this.store.pipe(select(isAuthenticated));
    this.loading = this.store.pipe(select(isAuthenticationLoading));
  }
  ngOnDestroy(): void {
    
  }
}
